import { render, staticRenderFns } from "./PastPresidents.vue?vue&type=template&id=7788943d&scoped=true&"
import script from "./PastPresidents.vue?vue&type=script&lang=js&"
export * from "./PastPresidents.vue?vue&type=script&lang=js&"
import style0 from "./PastPresidents.vue?vue&type=style&index=0&id=7788943d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788943d",
  null
  
)

export default component.exports